import styled from "@emotion/styled";

export const Separator = styled.hr`
    margin: 0.375rem;
    border: none;
    border-bottom: 1px solid var(--formant-color-primary-steel02);
`;

Separator.displayName = "Menu.Separator";
